<section class="video-partner-connect-section">
  <div class="box-container">
    <div class="box">
      <div class="box__left">
        <h2
          class="box__heading color-gray box__heading--desktop {{ translate.currentLang }}"
          [innerHTML]="'BECOME_OUR_PARTNER.PARTNER_CONNECT.HEADING' | translate"
        >
        </h2>

        <div class="box__heading-detail box__heading--mw">
          {{ 'BECOME_OUR_PARTNER.PARTNER_CONNECT.DETAIL' | translate }}
        </div>
      </div>

      <div class="box__right">
        <div class="box__item" (click)="linkVideo('-bD6XK_bCzA')" data-toggle="modal" data-target="#functionVideo">
          <div class="box__item-cover">
            <div class="box__item-cover--bg"></div>
            <picture>
              <source
                srcset="
                  https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/PartnerConnect2025.webp
                "
                type="image/webp"
              />
              <img
                src="https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/PartnerConnect2025.jpg"
                class="box__image"
                alt="อบรมบัญชีออนไลน์"
                title="อบรมบัญชีออนไลน์"
                loading="lazy"
              />
            </picture>

            <div class="box__item-cover--icon">
              <picture>
                <source
                  srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.webp"
                  type="image/webp"
                />
                <source
                  srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  type="image/jpeg"
                />
                <img
                  src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  class="icon-play"
                  alt="อบรมบัญชีออนไลน์"
                  title="อบรมบัญชีออนไลน์"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
